<div class="workspace-page">
  <header class="workspace-page__heading">
    <h1 class="workspace-page__title">Tasks</h1>
  </header>

  <!-- The same control the Board carries. These pages stopped being cards on
       the Dashboard, so without it the only way back to the leads you were
       looking at would be the browser button. It marks itself current from
       the URL, so nothing here has to say which tab this is. -->
  <app-leads-view-switcher class="rb-switcher"></app-leads-view-switcher>

  <div class="workspace-page__toolbar">
    <button type="button" class="br-btn br-btn--outline-secondary br-btn--sm" (click)="openBoard()">
      <br-icon>view_kanban</br-icon> Board
    </button>
    <button type="button" class="br-btn br-btn--outline-secondary br-btn--sm" (click)="openAnalytics()">
      <br-icon>insights</br-icon> Analytics
    </button>
  </div>

  <!-- The headline: how much is waiting, split the way the design splits it,
       and how stale the oldest of it is. -->
  <div class="br-card po-head" *ngIf="queue">
    <div class="po-count">
      <span class="po-num">{{ total }}</span>
      <span class="po-word">{{ total === 1 ? 'decision waiting' : 'decisions waiting' }}</span>
    </div>
    <div class="po-split" *ngIf="total">
      <span class="br-badge po-pill" *ngFor="let h of headlineKinds" [ngClass]="h.css"
            [class.po-pill-zero]="!countOf(h.kinds)">
        <b>{{ countOf(h.kinds) }}</b> {{ h.label }}
      </span>
    </div>
    <span class="po-stale" *ngIf="oldestDays as days">oldest has waited {{ days }}d</span>
  </div>

  <!-- What Scout is doing right now, so the queue is read as a live thing and
       not a static list. Unscoped: this page oversees the whole agent. -->
  <app-leads-agent-strip heading="Scout"></app-leads-agent-strip>

  <!-- The cards. Every action on them is a real command; the queue component
       owns which one, because it owns what each kind can honestly do. -->
  <app-agent-queue (loaded)="onQueue($event)"></app-agent-queue>

</div>
